import type {
  PatchRootFiInviteLinkBody,
  PatchRootFiInviteLinkResponse,
} from '@commenda/types/src/root-fi/types';
import {
  fetcher,
  messageFromApiErrorBody,
  readJsonResponseBody,
} from '@commenda/utils';

export async function patchRootFiInviteLink(
  inviteLinkUuid: string,
  body: PatchRootFiInviteLinkBody
): Promise<{
  success: boolean;
  data?: PatchRootFiInviteLinkResponse;
  error?: unknown;
}> {
  try {
    const response = await fetcher(
      `rootfi/invite-link/${encodeURIComponent(inviteLinkUuid)}`,
      {
        method: 'PATCH',
        body: {
          ...(body.companyName !== undefined
            ? { companyName: body.companyName }
            : {}),
          ...(body.syncFrom !== undefined ? { syncFrom: body.syncFrom } : {}),
          ...(body.useCases !== undefined ? { useCases: body.useCases } : {}),
          ...(body.syncConfig !== undefined
            ? {
                syncConfig: body.syncConfig?.map((row) => ({
                  interval: row.interval ?? 1,
                  frequency: row.frequency,
                  data_model: row.data_model,
                  category: row.category,
                  scope_access: row.scope_access,
                  enabled: row.enabled,
                  sync_from: row.sync_from ?? undefined,
                })),
              }
            : {}),
        },
      }
    );

    if (!response.ok) {
      const errorBody = await readJsonResponseBody(response);
      return {
        success: false,
        error: messageFromApiErrorBody(errorBody, 'Failed to update invite link'),
      };
    }

    const data = (await response.json()) as PatchRootFiInviteLinkResponse;
    return { success: true, data };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to update invite link';
    return { success: false, error: errorMessage };
  }
}
